import { makeStyles } from "components/mui-core";
import useVendorModalStyle from "vendor/material-dashboard-pro-react-v1/assets/jss/material-dashboard-pro-react/modalStyle";

const styles = () => ({
  //...useModalStyles(),
  ...makeStyles()(useVendorModalStyle),
});

export default styles;
